<template>
  <!-- user registration screen for the paying user grid -->
  <form class="form-signin" autocomplete="off" @submit.prevent="createUserLink">
    <label for="createUserName label-config">Nome</label>
    <div class="input-group mb-2 edit-input">
      <input
        type="text"
        id="createUserName"
        class="form-control input-length"
        v-bind:class="{ 'is-invalid': errors.name }"
        placeholder="Digite o nome do usuário"
        required
        autofocus
        v-model="userName"
      />
    </div>
    <span v-if="errors.name" class="error">
      <ul>
        <li v-for="msg in errors.name">{{ msg }}</li>
      </ul>
    </span>

    <label for="createUserLogin label-config"> Login</label>

    <div class="input-group mb-2 edit-input">
      <input
        type="text"
        id="createUserLogin"
        class="form-control input-length"
        v-bind:class="{ 'is-invalid': errors.login }"
        placeholder="Digite o login do usuário"
        required
        autofocus
        v-model="userLogin"
      />
    </div>
    <span v-if="errors.login" class="error">
      <ul>
        <li v-for="msg in errors.login">{{ msg }}</li>
      </ul>
    </span>
    <label for="createUserEmail label-config"> E-mail</label>

    <div class="input-group edit-input">
      <input
        type="email"
        id="createUserEmail"
        class="form-control input-length"
        v-bind:class="{ 'is-invalid': errors.email }"
        placeholder="Digite o e-mail do usuário"
        required
        autofocus
        v-model="userEmail"
      />
    </div>
    <span v-if="errors.email" class="error">
      <ul>
        <li v-for="msg in errors.email">{{ msg }}</li>
      </ul>
    </span>

    <!-- <label for="createRegistration label-config">Inscrição</label>
    <div class="input-group mb-2 edit-input">
      <input
        type="text"
        id="createRegistration"
        class="form-control input-length"
        v-bind:class="{ 'is-invalid': errors.registration }"
        placeholder="Digite o CPF/CNPJ do usuário"
        required
        v-model="userRegistration"
        v-mask="maskCPFCNPJ"
        autofocus
        v-on:focus="setMaskCPFCNPJ"
      />
    </div>
    <span v-if="errors.registration" class="error">
      <ul>
        <li v-for="msg in errors.registration">
          {{ msg }}
        </li>
      </ul>
    </span> -->

    <div class="access-center">
      <button class="btn btn-lg access" id="sendCreateUser" type="submit">Avançar</button>
      <br /><br />
    </div>
  </form>
</template>
<script>
import axios from "axios";
import LinkUser from "./LinkUser";
import Vue from "vue";

export default {
  components: { LinkUser },
  name: "CreateUser",
  data() {
    return {
      userName: "",
      userLogin: "",
      userEmail: "",
      maskCPFCNPJ: "",
      errors: [],
      //   userRegistrationType: "",
      // userRegistration: "",
    };
  },

  methods: {
    createUserLink: function () {
      // this.userRegistration = this.userRegistration.replace(/\D/g, "");

      let data = {
        user_name: this.userName,
        user_login: this.userLogin,
        user_email: this.userEmail,
        // user_registration_type: this.userRegistrationType,
        // user_registration: this.userRegistration,
      };

      // data.user_registration_type = "cnpj";
      // if (data.user_registration.length === 11) {
      //   data.user_registration_type = "cpf";
      // }

      axios
        .get(`${process.env.API_PBM}/user/checkFirstStepSaveUser`, {
          params: {
            login: this.userLogin,
            name: this.userName,
            email: this.userEmail,
            // registration: this.userRegistration,
          },
        })
        .then((response) => {
          this.$emit("stepUserComplete", data);
        })
        .catch((error) => {
          this.errors = error.response.data.message;
          Vue.$toast.error("Verifique os campos com erro", {
            position: "top-right",
            duration: 5000,
          });
        });
    },
    setMaskCPFCNPJ: function () {
      this.maskCPFCNPJ = ["###.###.###-##", "##.###.###/####-##"];
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.text-join {
  color: rgb(100, 95, 95);
  font-size: 20px;
  margin-left: 35%;
}
.form-control:disabled {
  background-color: #e9ecef;
  opacity: 1;
}

.form-control {
  color: gray;
}

.input-length {
  width: 80%;
  margin: 0 auto;
}

.edit-button {
  background-color: #ced4da;
  height: 100%;
  border: none;
  border-radius: 2px;
}
label {
  display: inline-block;
  font-size: 17px;
  color: rgb(100, 95, 95);
}
.icons {
  font-size: 20px;
  color: rgb(100, 95, 95);
  cursor: pointer;
  width: 100%;
}

.error {
  display: inline-block;
  font-size: 13px;
  color: #b0191a;
  width: 100%;
  margin-left: -20px;
}
.text-align-center {
  color: rgb(100, 95, 95);
  font-size: 14px;
}

.access {
  color: #fff;
  width: 35%;
  margin-top: 15px;
  border-radius: 6px;
  cursor: pointer;
  padding: 5px;
  font-size: 17px;
  text-decoration: none;
}
.access-center {
  text-align: center;
}

@media only screen and (max-width: 900px) {
  .text-join {
    color: rgb(100, 95, 95);
    font-size: 20px;
    margin-left: 31%;
  }

  label {
    display: inline-block;
    margin-left: 33px;
    font-size: 17px;
    color: rgb(100, 95, 95);
  }
  .text-align-center {
    margin-top: 5px;
    margin-left: 33px;
    color: rgb(100, 95, 95);
    font-size: 14px;
  }
  .edit-input {
    width: 80%;
    margin-left: 30px;
  }

  .modal {
    padding: 0px !important;
  }
  .error {
    display: inline-block;
    font-size: 13px;
    color: #b0191a;
    width: 100%;
    margin-left: 0px;
  }
}
@media only screen and (min-width: 960px) {
  /* styles for browsers larger than 960px; */
  .modal-dialog {
    margin-top: 4%;
  }
}
@media only screen and (min-width: 1440px) {
  /* styles for browsers larger than 1440px; */
  .modal-dialog {
    margin-top: 7%;
  }
}
@media only screen and (max-device-width: 480px) {
  /* styles for mobile browsers smaller than 480px; (iPhone) */
  .modal-dialog {
    margin-top: 20%;
  }
}
@media only screen and (device-width: 768px) {
  /* default iPad screens */
  .modal-dialog {
    margin-top: 30%;
  }
}

@media only screen and (min-width: 2000px) {
  .modal-dialog {
    margin-top: 12%;
  }
  /* for sumo sized (mac) screens */
}
/* different techniques for iPad screening */
@media only screen and (min-device-width: 481px) and (max-device-width: 1024px) and (orientation: portrait) {
  /* For portrait layouts only */
  .modal-dialog {
    margin-top: 35%;
  }
}

@media only screen and (min-device-width: 481px) and (max-device-width: 1024px) and (orientation: landscape) {
  /* For landscape layouts only */
  .modal-dialog {
    margin-top: 35%;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/components/user/create/CreateUser.vue